import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { WorkCenter } from '../work-center'
import { WorkCenterDetailComponent } from '../work-center-detail/work-center-detail.component'

@Component({
  selector: 'app-work-center-detail-side',
  templateUrl: './work-center-detail-side.component.html',
  styleUrls: ['./work-center-detail-side.component.scss'],
  imports: [WorkCenterDetailComponent],
})
export class WorkCenterDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public workCenter: WorkCenter
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.workCenter = route.snapshot.data['workCenter']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
